module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


    const maxFacets = 12;
    const activeFacets = facets.filter( (facet) => !facet.skip );

;
__p += '<ul class="mdl_filter__list">\n\n    ';
 activeFacets.forEach( (facet, index) => {
        const filterClassName = [ 'mdl_filter__item' ];

        if ( 'TREE' === facet.filterStyle ) {
            filterClassName.push( 'mdl_filter__item--tree mdl_filter__item--hidden_in_list' );
        }
        if ( facet.variant ) {
            filterClassName.push( `mdl_filter__item--${facet.variant}` );
        }
        if ( [ 'Price' ].includes( facet.associatedFieldName ) ) {
            filterClassName.push( 'mdl_filter__item--nodefaultmultiselect' );
        }
        if ( facet.hidden ) {
            filterClassName.push( 'mdl_filter__item--hidden_in_list' );
        }

        if ( index > maxFacets && ( ! facet.hidden && ! facet.skip ) ) {
            filterClassName.push( 'mdl_filter__item--secondary' )
        }
        if ( facet.count ) {
            filterClassName.push( 'is-selected' );
        }
    ;
__p += '\n        <li class="' +
((__t = ( filterClassName.join( ' ' ) )) == null ? '' : __t) +
'" data-identifier="' +
((__t = ( facet.associatedFieldName )) == null ? '' : __t) +
'">\n            <button class="mdl_filter__item-trigger js_filter__item-trigger" type="button">\n                <span class="mdl_filter__item-title">' +
((__t = ( facet.name )) == null ? '' : __t) +
'</span>\n                ';
 if ( facet.selectedElements.length > 0 ) { ;
__p += '\n                <span class="mdl_filter__item-count">' +
((__t = ( facet.selectedElements.length )) == null ? '' : __t) +
'</span>\n                ';
 } ;
__p += '\n            </button>\n            <fieldset class="mdl_filter__item-container">\n                <!-- Insert Facet here -->\n            </fieldset>\n        </li>\n    ';
 } ) ;
__p += '\n\n    ';
 if ( activeFacets.length > maxFacets + 1 ) { ;
__p += '\n    <li class="mdl_filter__item mdl_filter__item--show-more-filter js-filter__item--show-more-filter en_hidden_desktop_down">\n        <button class="mdl_filter__item-trigger js_filter__item-trigger-show-more-filter" type="button" aria-label="Mehr Filter">\n            <span class="mdl_filter__item-title">Mehr Filter</span>\n        </button>\n    </li>\n    ';
 } ;
__p += '\n    <li class="mdl_filter__item mdl_filter__item--all-filter js-filter__item--all-filter en_hidden_desktop_up">\n        <button class="mdl_filter__item-trigger js_filter__item-trigger-all-filter" type="button" aria-label="Alle Filter">\n            <span class="mdl_filter__item-title">Alle Filter</span>\n        </button>\n    </li>\n</ul>\n';

}
return __p
};
